module.exports = __webpack_public_path__ + "img/web.1848c8b.svg";